import logo from './logo.svg';
import './App.css';

import { BrowserRouter, Route,Routes } from 'react-router-dom';
import { Home } from './Home';
import { ContactUs } from './ContactUs';
function App() {
  return (
    <>
    
    <BrowserRouter>
    
      <Routes>

      <Route index element={<Home/>} />
      <Route path="Home" element={<Home/>}/>
      <Route path = "Contact us" element={<ContactUs/>}/>
     
      </Routes>
    
      

    </BrowserRouter>
    </> );
}


export default App;
